<div class="dialog-container">
  <div mat-dialog-content>
    <div class="text-center">
      <img src="../../../../assets/images/svg/warning-icon.svg" alt=''>
      @if (data.title) {
      <h5 class="mt-2">{{data.title}}</h5>
      }
      <h2 class="dialog-message">{{data.message}}</h2>
    </div>
  </div>
  <app-dialog-footer
    [dialogResult]="data"
    [showConfirm]="!!data.showConfirmButton"
    [confirmLabel]="data.confirmBtn"
    [confirmVariant]="data.isDelete ? 'danger' : 'primary'"
    wrapperClass="setup-footer"
  />
</div>
